<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="注册" left-arrow @click-left="$router.push('login')" />
    </van-sticky>
    <van-cell-group>
      <van-field v-model="form.uuid" placeholder="请输入推荐人手机号" :readonly="readonly">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/invite.png" alt class="inviteIcon" />
        </div>
      </van-field>
      <van-field v-model="form.name" placeholder="请输入真实姓名">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/phone.png" alt />
        </div>
      </van-field>
      <van-field v-model="form.phone" placeholder="请输入手机号码">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/phone.png" alt />
        </div>
      </van-field>
      <!-- <van-field v-model="form.code" placeholder="请输入验证码" clearable>
        <div slot="left-icon">
          <img src="../../assets/imgs/login/psd.png" alt />
        </div>
        <van-button slot="button" size="small" type="primary" @click="send()" :disabled="!disabled">{{codetext}}
        </van-button>
      </van-field> -->
      <van-field v-model="form.password" placeholder="请输入登录密码" type="password">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/psd.png" alt />
        </div>
      </van-field>
      <van-field v-model="form.password_re" placeholder="请确认登录密码" type="password">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/psd.png" alt />
        </div>
      </van-field>
      <!-- <van-field v-model="form.pay_password" placeholder="请输入支付密码" type="password">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/psd.png" alt />
        </div>
      </van-field>
      <van-field v-model="form.pay_password_re" placeholder="请输入支付密码" type="password">
        <div slot="left-icon">
          <img src="../../assets/imgs/login/psd.png" alt />
        </div>
      </van-field> -->
    </van-cell-group>
    <!--日期选择 -->
    <van-datetime-picker v-if='datePicker' v-model="currentDate" type="date" title="选择年月日" :min-date="minDate"
      :max-date="maxDate" @confirm="getTime" @cancel='datePicker=false' />
    <van-button @click="submitReg" class="regBtn">注册</van-button>
    <!-- <p class="toLogin" @click="$router.push('login')">
      已有账号?
      <span>立即登录</span>
    </p> -->
    <!-- <p class="regText">
      <van-checkbox v-model="checkeds"><span @click="$router.push('regText')"
          style="color: #FA4A42;">我已详细阅读并充分理解《注册协议》</span></van-checkbox>
    </p> -->
    <!-- <div class="downText" @click='downloadApp'>点击下载APP</div> -->
  </div>
</template>
<script>
  import { register, sendSms } from "@/api/login";
  export default {
    data() {
      return {
        disabled: true,
        checked: true,
        checkeds: false,
        codetext: "获取验证码",
        readonly: false,
        datePicker: false,
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(2100, 10, 1),
        currentDate: new Date(),
        form: {
          phone: "",
          uuid: "",
          password: "",
          password_re: "",
          name: "",
        }
      };
    },
    created() {
      if (this.$route.query.uuid) {
        this.readonly = true;
        this.form.uuid = this.$route.query.uuid;
      }
    },
    methods: {
      // 选择出生日期
      getTime(value) {
        // 确定按钮，时间格式化并显示在页面上
        let date = value;
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        if (m >= 1 && m <= 9) {
          m = "0" + m;
        }
        if (d >= 1 && d <= 9) {
          d = "0" + d;
        }
        let timer = y + "-" + m + '-' + d;
        this.form.birth_time = timer;
        this.datePicker = false;
      },
      send() {
        sendSms({ phone: this.form.phone }).then(res => {
          this.$toast('短信已发送到您手机，请注意查收!');
          this.countDown(60);
        });
      },
      countDown(time) {
        if (time === 0) {
          this.disabled = true;
          this.codetext = "获取验证码";
          return;
        } else {
          this.disabled = false;
          this.codetext = "重新发送(" + time + ")";
          time--;
        }
        setTimeout(() => {
          this.countDown(time);
        }, 1000);
      },
      // 注册
      submitReg() {
        if (!this.form.phone || !this.form.password || !this.form.password_re||!this.form.name) {
          this.$toast("请填写完整注册信息!");
          return;
        }
        register(this.form).then(res => {
          setTimeout(() => {
            this.$toast("注册成功!");
          }, 200);
            this.$router.push("login");
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .van-checkbox {
    justify-content: center;
    color: #FA4A42;
  }
  .downText {
    width:100px;
    margin: 30px auto;
    color: #fff;
  }
  .wrap {
    position: relative;
    background: url(../../assets/imgs/login/loginBg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    left: 0;
    width: 100%;
    height: 100vh;
    text-align: center;
    font-size: 15px;
  }

  .van-cell-group {
    width: 320px;
    margin: 0 auto;
    padding-top: 40px;
    background: transparent;

    .van-cell {
      background-color: transparent;
      padding: 16px 0;

      /deep/ .van-field__left-icon {
        width: 23px;

        img {
          width: 17.5px;
          height: 21px;
          margin-top: 2px;
        }

        .inviteIcon {
          width: 20px;
          height: 19.5px;
        }
      }
    }
  }

  .regBtn {
    width: 295px;
    display: block;
    height: 40px;
    background: linear-gradient(#008FFF, #007EFF);
    font-size: 16px;
    font-weight: bold;
    margin: 42px auto 0;
    border-radius: 20px;
    color: #fff;
    line-height: 40px;
    font-weight: bold;
  }

  .toLogin {
    text-align: center;
    margin-top: 18px;

    span {
      color: #FA4A42;
    }
  }

  .van-button--primary {
    color: #FA4A42;
    border: 1px solid #FA4A42;
    background: transparent;
    border-radius: 15px;
  }

  /deep/ .van-picker__mask {
    z-index: 100;
  }

  .regText {
    margin: 20px auto;
    color: #FA4A42;
    font-size: 14px;
  }
</style>